export const testCaseStatuses = {
  ready: {
    label: 'Ready',
    color: 'bg-primary',
    sortOrder: 2,
  },
  inProgress: {
    label: 'In progress',
    color: 'bg-warning',
    sortOrder: 1,
  },
  blocked: {
    label: 'Blocked',
    color: 'bg-dark',
    sortOrder: 3,
  },
  finished: {
    label: 'Finished',
    color: 'bg-secondary',
    sortOrder: 4,
  },
}
